// var isOnlineEnv = location.href.indexOf('zhitong.baidu.com') > -1;
const href = location.href;
export const isOnlineEnv = href.indexOf('zhitong.baidu.com') > -1 ||
    href.indexOf('antibot.baidu.com') > -1 ||
    process.env.VUE_APP_ONLINE_PROXY;
// var isOnlineEnv = location.href.indexOf('.baidu.com') > -1;
// var isTest = location.host.indexOf('shitong-ais.baidu.com') > -1;
// var passDomain = isOnlineEnv ? 'passport.baidu.com' : 'passport.qatest.baidu.com';
export const isDev = href.indexOf('dev') > -1 || href.indexOf('debug') > -1;
